var exports = {
  "K": "x0a7806d5--c2cd63--tour-label",
};

module.exports = exports;
